import { useIsLoggedIn, useIsLoggingIn } from '@order/AuthMachine';

import { useReorderState } from '../../../ReorderingScreen';
import { useCheckoutContext } from '../../CheckoutProvider';

export const useConnectedCheckoutRenderControl = () => {
  const context = useCheckoutContext();

  return useCheckoutRenderControl(context);
};

export const useCheckoutRenderControl = (
  props: Pick<
    ReturnType<typeof useCheckoutContext>,
    | 'cart'
    | 'isFetchingCart'
    | 'isCartDelivery'
    | 'isLoadingCredits'
    | 'isLoadingDeliveryEstimate'
    | 'isCartEmpty'
  >,
) => {
  const {
    cart,
    isFetchingCart,
    isCartDelivery,
    isLoadingCredits,
    isLoadingDeliveryEstimate,
    isCartEmpty,
  } = props;

  const { reordering } = useReorderState();
  const isLoggingIn = useIsLoggingIn();
  const isLoggedIn = useIsLoggedIn();
  const isLoggedOut = !isLoggedIn;

  const hasCart = !isCartEmpty && Boolean(cart?.id);
  const hasCartAddressIfNeeded =
    !isCartDelivery || Boolean(cart?.deliveryOrderDetail?.address?.id);

  const isLoadingCheckout =
    isFetchingCart ||
    isLoggingIn ||
    isLoadingCredits ||
    isLoadingDeliveryEstimate;
  const isCustomerDataReady = Boolean(isLoggedIn && !reordering);
  const isCartValid = Boolean(
    isCustomerDataReady && hasCart && hasCartAddressIfNeeded,
  );

  return {
    isLoggedOut,
    isLoadingCheckout,
    isCustomerDataReady,
    isCartValid,
  };
};
